const overrides = (palette, typography) => ({
  root: {
    "&$disabled": {
      color: palette.action.selected
    }
  }
})

export default overrides
